
import representativesGroup from './representativesGroup';
import representative from './representative';
import scheduleTripStore from './schedule-trip/scheduleTripStore';

export default {
    representativesGroup,
    representative,
    ...scheduleTripStore,
}